import Swal from "sweetalert2"

export function useCotizadorActions({

    sinVuelo,

    origen,
    destino,

    fechaIda,
    fechaRegreso,

    habitaciones,

    telefono,

    dias,
    dias1,
    dias2,

    soloDirectos,

    visa,

    buscarVuelos,

    validarPasajeros,

    totales,

    resultados,

    loading,

    generarCotizacion,
    generarCotizacionCorp,

    searchId,

    guardarVuelo,
    valorRecobro,

    modalVueloVisible,
    porcentajeHoteles,
    porcentajeVuelos,
    precioTraslados,
    hayResultados,
    cotizando,

    // alerta contextual: por defecto Swal global (compatibilidad con Corp)
    notificar = (opts) => Swal.fire(opts)

}) {

    async function handleBuscar() {

        if (sinVuelo.value) return false

        if (!origen.value || !destino.value) {
            await notificar({ icon: "warning", title: "Faltan datos" })
            return false
        }

        if (origen.value === destino.value) {
            await notificar({ icon: "warning", title: "Origen y destino iguales" })
            return false
        }

        if (!validarPasajeros()) return false

        const tot = totales()

        const params = {
            origen: origen.value,
            destino: destino.value,
            fechaIda: fechaIda.value,
            fechaRegreso: fechaRegreso.value,
            habitaciones: habitaciones.value,
            telefono: telefono.value,
            dias: dias.value,
            diasCombi1: dias1.value,
            diasCombi2: dias2.value,
            soloDirectos: soloDirectos.value,
            visa: visa.value,
            ...tot
        }

        await buscarVuelos(params)

        // Ejecutar cotización automáticamente (solo flujo normal: corp no la encadena)
        if (hayResultados?.value && cotizando) {
            cotizando.value = true
            try {
                const ok = await handleCotizar()
                return ok  // ← propaga el resultado
            } finally {
                cotizando.value = false
            }
        }

        return false
    }

    async function handleCotizar() {
        try {
            loading.value = true

            // SIN VUELO
            if (sinVuelo.value) {
                const tot = totales()
                const data = await guardarVuelo(
                    null,
                    {
                        fechaIda: fechaIda.value,
                        fechaRegreso: fechaRegreso.value,
                        origen: origen.value,
                        destino: destino.value,
                        habitaciones: habitaciones.value,
                        adultos: tot.adultos,
                        ninos: tot.ninos,
                        infantes: tot.infantes,
                        edadesNinos: habitaciones.value.flatMap(h => h.edadesNinos || []),
                        edadesInfantes: habitaciones.value.flatMap(h => h.edadesInfantes || []),
                        telefono: telefono.value
                    },
                    null,
                    { silent: true, sinVuelo: true }
                )

                if (!data) return false  // ← false

                searchId.value = data.searchId

                const res = await generarCotizacion({
                    searchId: data.searchId,
                    precio: 0,
                    vuelos: [
                        { tramo: "ida", ida: data.payload.ida },
                        { tramo: "regreso", ida: data.payload.regreso }
                    ],
                    valorRecobro
                })

                return !!res
            }

            // VALIDAR SEARCH ID
            if (!searchId.value) {
                await notificar({ icon: "error", title: "No existe searchId" })
                return false  // ← false
            }

            const vuelosData = resultados.value?.vuelos || {}

            const tieneResultados =
                Array.isArray(vuelosData.resultados) &&
                vuelosData.resultados.length > 0

            const tieneVueloManual =
                vuelosData?.ida &&
                vuelosData?.regreso &&
                !tieneResultados

            const tieneVueloManualMulti =
                tieneResultados &&
                vuelosData.resultados.every(v => v.precioNum)

            const tieneVueloAutomatico =
                tieneResultados &&
                !tieneVueloManualMulti

            if (!tieneVueloAutomatico && !tieneVueloManual && !tieneVueloManualMulti) {
                await notificar({ icon: "error", title: "No hay vuelos para cotizar" })
                return false  // ← false
            }

            // VUELO MANUAL MULTI
            if (tieneVueloManualMulti) {
                const precio = Number(String(resultados.value.vuelos.precio).replace(/[^\d]/g, ""))
                if (!precio || isNaN(precio)) {
                    await notificar({ icon: "error", title: "El vuelo multidestino no tiene precio válido" })
                    return false  // ← false
                }
                const vuelos = JSON.parse(JSON.stringify(resultados.value.vuelos.resultados))
                const res = await generarCotizacion({ searchId: searchId.value, precio, vuelos, valorRecobro })
                return !!res
            }

            // VUELO AUTOMÁTICO
            if (tieneVueloAutomatico) {
                const precioRaw = resultados.value?.vuelos?.precio || resultados.value?.vuelos?.mejor?.total
                const precio = Number(String(precioRaw).replace(/[^\d]/g, ""))
                if (!precio || isNaN(precio)) {
                    await notificar({ icon: "error", title: "No hay precio disponible" })
                    return false  // ← false
                }
                const res = await generarCotizacion({ searchId: searchId.value, precio, vuelos: resultados.value.vuelos.resultados, valorRecobro })
                return !!res
            }

            // VUELO MANUAL
            if (tieneVueloManual) {
                const precio = Number(String(resultados.value.vuelos.precio).replace(/[^\d]/g, ""))
                if (!precio || isNaN(precio)) {
                    await notificar({ icon: "error", title: "El vuelo manual no tiene precio válido" })
                    return false  // ← false
                }
                const vuelos = [
                    { tramo: "ida", ida: JSON.parse(JSON.stringify(resultados.value.vuelos.ida)) },
                    { tramo: "regreso", ida: JSON.parse(JSON.stringify(resultados.value.vuelos.regreso)) }
                ]
                const res = await generarCotizacion({ searchId: searchId.value, precio, vuelos, valorRecobro })
                return !!res
            }

        } catch (err) {
            console.error(err)
            notificar({ icon: "error", title: "Error", text: err.message || "Error generando cotización" })
            return false  // ← false

        } finally {
            loading.value = false
        }
    }

    async function handleCotizarCorp() {
        console.log("SIN VUELO:", sinVuelo.value)
        console.log("DESTINO:", destino.value)
        console.log("RESULTADOS:", resultados.value)
        console.log("SEARCH ID:", searchId.value)

        const porcentajes = {
            porcentajeHoteles: Number(porcentajeHoteles.value || 0),
            porcentajeVuelos: Number(porcentajeVuelos.value || 0),
        }

        try {

            loading.value = true

            // =========================
            // 🏨 SIN VUELO
            // =========================

            // =========================
            // 🏨 SIN VUELO
            // =========================
            if (sinVuelo.value) {

                const tot = totales()

                const data = await guardarVuelo(
                    null,
                    {
                        fechaIda: fechaIda.value,
                        fechaRegreso: fechaRegreso.value,
                        origen: origen.value,
                        destino: destino.value,
                        habitaciones: habitaciones.value,
                        adultos: tot.adultos,
                        ninos: tot.ninos,
                        infantes: tot.infantes,
                        edadesNinos: habitaciones.value.flatMap(h => h.edadesNinos || []),
                        edadesInfantes: habitaciones.value.flatMap(h => h.edadesInfantes || []),
                        telefono: telefono.value
                    },
                    null,
                    {
                        silent: true,
                        sinVuelo: true
                    }
                )

                if (!data) {
                    return false
                }

                // ✅ guardar searchId generado
                searchId.value = data.searchId

                // ✅ generar cotización directamente
                const res = await generarCotizacionCorp({
                    searchId: data.searchId,

                    precio: 0,

                    vuelos: [
                        {
                            tramo: "ida",
                            ida: data.payload.ida
                        },
                        {
                            tramo: "regreso",
                            ida: data.payload.regreso
                        }
                    ],
                    porcentajes,
                    precioTraslados
                })

                return !!res
            }

            // =========================
            // 🔍 VALIDAR SEARCH ID
            // =========================

            if (!searchId.value) {

                await notificar({
                    icon: "error",
                    title: "No existe searchId"
                })

                return false
            }

            // =========================
            // DETECTAR TIPOS
            // =========================

            const vuelosData = resultados.value?.vuelos || {}

            // 🔥 NORMAL / DECAMERON / MULTIDESTINO AUTOMÁTICO
            const tieneResultados =
                Array.isArray(vuelosData.resultados) &&
                vuelosData.resultados.length > 0

            // 🔥 MANUAL SIMPLE
            const tieneVueloManual =
                vuelosData?.ida &&
                vuelosData?.regreso &&
                !tieneResultados

            // 🔥 MULTIDESTINO MANUAL
            const tieneVueloManualMulti =
                tieneResultados &&
                vuelosData.resultados.every(v => v.precioNum)

            // 🔥 AUTOMÁTICO
            const tieneVueloAutomatico =
                tieneResultados &&
                !tieneVueloManualMulti

            if (
                !tieneVueloAutomatico &&
                !tieneVueloManual &&
                !tieneVueloManualMulti
            ) {

                await notificar({
                    icon: "error",
                    title: "No hay vuelos para cotizar"
                })

                return false
            }
            // =========================
            // ✈️ VUELO MANUAL MULTI
            // =========================

            if (tieneVueloManualMulti) {

                const precio = Number(
                    String(resultados.value.vuelos.precio)
                        .replace(/[^\d]/g, "")
                )

                if (!precio || isNaN(precio)) {

                    await notificar({
                        icon: "error",
                        title: "El vuelo multidestino no tiene precio válido"
                    })

                    return false
                }

                const vuelos = JSON.parse(
                    JSON.stringify(resultados.value.vuelos.resultados)
                )

                console.log("COTIZACION MANUAL MULTI", {
                    searchId: searchId.value,
                    precio,
                    vuelos
                })

                const res = await generarCotizacionCorp({
                    searchId: searchId.value,
                    precio,
                    vuelos,
                    porcentajes,
                    precioTraslados
                })

                return !!res
            }
            // =========================
            // ✈️ VUELO AUTOMÁTICO
            // =========================

            if (tieneVueloAutomatico) {

                const precioRaw =
                    resultados.value?.vuelos?.precio ||
                    resultados.value?.vuelos?.mejor?.total

                const precio = Number(
                    String(precioRaw).replace(/[^\d]/g, "")
                )

                if (!precio || isNaN(precio)) {

                    await notificar({
                        icon: "error",
                        title: "No hay precio disponible"
                    })

                    return false
                }

                console.log("COTIZACION AUTO", {
                    searchId: searchId.value,
                    precio,
                    vuelos: resultados.value.vuelos.resultados
                })

                const res = await generarCotizacionCorp({
                    searchId: searchId.value,
                    precio,
                    vuelos: resultados.value.vuelos.resultados,
                    porcentajes,
                    precioTraslados
                })

                return !!res
            }

            // =========================
            // ✍️ VUELO MANUAL
            // =========================
            if (tieneVueloManual) {

                const precio = Number(
                    String(resultados.value.vuelos.precio)
                        .replace(/[^\d]/g, "")
                )

                if (!precio || isNaN(precio)) {

                    await notificar({
                        icon: "error",
                        title: "El vuelo manual no tiene precio válido"
                    })

                    return false
                }

                const vuelos = [
                    {
                        tramo: "ida",
                        ida: JSON.parse(
                            JSON.stringify(resultados.value.vuelos.ida)
                        )
                    },
                    {
                        tramo: "regreso",
                        ida: JSON.parse(
                            JSON.stringify(resultados.value.vuelos.regreso)
                        )
                    }
                ]

                console.log("COTIZACION MANUAL", {
                    searchId: searchId.value,
                    precio,
                    vuelos
                })

                const res = await generarCotizacionCorp({
                    searchId: searchId.value,
                    precio,
                    vuelos,
                    porcentajes,
                    precioTraslados
                })

                return !!res
            }

        } catch (err) {

            console.error(err)

            notificar({
                icon: "error",
                title: "Error",
                text: err.message || "Error generando cotización"
            })

            return false

        } finally {

            loading.value = false

        }

    }

    async function handleGuardarVuelo(payload) {

        const tot = totales()

        const data = await guardarVuelo(
            searchId.value,

            {
                fechaIda: fechaIda.value,
                fechaRegreso: fechaRegreso.value,

                origen: origen.value,
                destino: destino.value,

                habitaciones: habitaciones.value,

                adultos: tot.adultos,
                ninos: tot.ninos,
                infantes: tot.infantes,

                edadesNinos: habitaciones.value.flatMap(
                    h => h.edadesNinos || []
                ),

                edadesInfantes: habitaciones.value.flatMap(
                    h => h.edadesInfantes || []
                ),

                telefono: telefono.value
            },

            payload
        )
        console.log("2 - Data:", data)

        if (!data) {
            console.log("3 - No hay data")
            return
        }

        console.log("4 - Antes de cerrar modal")

        searchId.value = data.searchId
        resultados.value.vuelos = data.payload

        modalVueloVisible.value = false

        await Swal.fire({
            icon: "success",
            title: "Vuelo guardado",
            text: "El vuelo manual fue agregado correctamente"
        })

        console.log("5 - Modal:", modalVueloVisible.value)

    }

    async function handleAbrirVueloManual() {

        // =========================
        // VALIDACIONES GENERALES
        // =========================

        if (!origen.value || !destino.value) {
            return Swal.fire({
                icon: "warning",
                title: "Faltan datos",
                text: "Debes seleccionar origen y destino"
            })
        }

        if (!fechaIda.value || !fechaRegreso.value) {
            return Swal.fire({
                icon: "warning",
                title: "Fechas requeridas",
                text: "Debes seleccionar fecha de ida y regreso"
            })
        }

        if (!telefono.value) {
            return Swal.fire({
                icon: "warning",
                title: "Teléfono requerido"
            })
        }

        if (origen.value === destino.value) {
            return Swal.fire({
                icon: "warning",
                title: "Origen y destino no pueden ser iguales"
            })
        }

        const idaFecha = new Date(fechaIda.value)
        const regresoFecha = new Date(fechaRegreso.value)

        if (regresoFecha <= idaFecha) {
            return Swal.fire({
                icon: "warning",
                title: "Fechas inválidas"
            })
        }

        if (!validarPasajeros()) return

        const tot = totales()

        if (tot.adultos === 0) {
            return Swal.fire({
                icon: "warning",
                title: "Debe haber al menos 1 adulto"
            })
        }

        // =========================
        // RESUMEN HABITACIONES
        // =========================

        const resumenHabitaciones = habitaciones.value
            .map((hab, i) => {

                return `
        <div style="text-align:left; margin-bottom:10px;">
          <strong>Habitación ${i + 1}</strong><br>
          Adultos: ${hab.adultos}<br>
          Niños: ${hab.ninos}<br>
          Infantes: ${hab.infantes}
        </div>
      `
            })
            .join("")

        const confirmacion = await Swal.fire({
            icon: "question",
            title: "Confirmar datos",
            html: `
      <div style="text-align:left;">
        <p><strong>Origen:</strong> ${origen.value}</p>
        <p><strong>Destino:</strong> ${destino.value}</p>
        <p><strong>Fecha ida:</strong> ${fechaIda.value}</p>
        <p><strong>Fecha regreso:</strong> ${fechaRegreso.value}</p>
        <hr>
        ${resumenHabitaciones}
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar"
        })

        if (!confirmacion.isConfirmed) return



        modalVueloVisible.value = true
    }

    return {

        handleBuscar,

        handleCotizar,

        handleGuardarVuelo,

        handleAbrirVueloManual,

        handleCotizarCorp

    }

}